import AjaxService from "services/base/Ajax.service";

class PersonService extends AjaxService {
  async getPersons(includeDeleted = false) {
    return this.get(`/person${includeDeleted ? "?includeDeleted=true" : ""}`);
  }

  async getNotificationCount() {
    return this.get("/person/notificationCount");
  }

  async getPersonInfo(personId) {
    return this.get(`/person/${personId}`);
  }

  async upsertPerson(data) {
    return this.post("/person/upsert", data);
  }

  async bulkInsert(data) {
    return this.post("/person/bulk/insert", data);
  }

  async registerDeviceToken(payload) {
    return this.post("/person/device/register", payload);
  }

  async updatePassword(personId, data) {
    return this.put(`/person/${personId}/password/update`, data);
  }

  async sendPersonCode(data) {
    return this.post("/person/sendCode", data);
  }

  async resetPersonPassword(personId) {
    return this.post("/person/user/reset-password", { personId });
  }

  async togglePersonStatus(personId) {
    return this.post("/person/user/toggle-status", { personId });
  }

  async updatePerson(personId, data) {
    return this.put(`/person/${personId}`, data);
  }

  async addPersonToTeam(personId, teamId) {
    return this.post(`/person/${personId}/teams/${teamId}`);
  }

  async removePersonFromTeam(personId, teamId) {
    return this.delete(`/person/${personId}/teams/${teamId}`);
  }

  async addPersonToLocation(personId, locationId) {
    return this.post(`/person/${personId}/locations/${locationId}`);
  }

  async removePersonFromLocation(personId, locationId) {
    return this.delete(`/person/${personId}/locations/${locationId}`);
  }

  async lookupZip(zip) {
    return this.get(`/person/lookup/zip/${zip}`);
  }

  async lookupCityState(city, state) {
    return this.get(
      `/person/lookup/citystate?city=${encodeURIComponent(city)}&state=${encodeURIComponent(state)}`,
    );
  }

  async batchUpsertTeamPersons(teamId, personIds) {
    return this.put(`/person/teams/${teamId}/batch`, {
      personIds,
      type: "team",
    });
  }

  async batchUpsertLocationPersons(locationId, personIds) {
    return this.put(`/person/locations/${locationId}/batch`, {
      personIds,
      type: "location",
    });
  }

  async deletePerson(personId) {
    return this.delete(`/person/${personId}`);
  }
}

export default new PersonService();
